"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdtfBaseWriteableComponent = void 0;
const SdtfUtils_1 = require("../../utils/SdtfUtils");
class SdtfBaseWriteableComponent {
    constructor() {
        this.componentId = (0, SdtfUtils_1.createComponentId)();
    }
    toDataObject() {
        return (0, SdtfUtils_1.userComponentToDataObject)(this);
    }
}
exports.SdtfBaseWriteableComponent = SdtfBaseWriteableComponent;
//# sourceMappingURL=SdtfBaseWriteableComponent.js.map